var map = {
	"./template.betgalaxy": 2111,
	"./template.betgalaxy.tsx": 2111,
	"./template.betprofessor": 1060,
	"./template.betprofessor.tsx": 1060,
	"./template.betroyale": 1061,
	"./template.betroyale.tsx": 1061,
	"./template.default": 654,
	"./template.default.tsx": 654,
	"./template.fiestabet": 1062,
	"./template.fiestabet.tsx": 1062,
	"./template.puntcity": 1063,
	"./template.puntcity.tsx": 1063,
	"./template.puntgenie": 1064,
	"./template.puntgenie.tsx": 1064,
	"./template.questbet": 1065,
	"./template.questbet.tsx": 1065,
	"./template.ts": 963,
	"./template.volcanobet": 1066,
	"./template.volcanobet.tsx": 1066,
	"./template.wellbet": 1067,
	"./template.wellbet.tsx": 1067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2418;